import React from 'react'
import { Button, Box } from '@mui/material'
import logo from './latvija-lv-logo.png'

const sx = {
  label: {
    marginTop: 4,
    textAlign: 'center',
    color: '#616161',
  },
  btn: {
    marginTop: 1,
    width: '100%',
    minWidth: 260,
    minHeight: '45px',
  },
  img: {
    marginTop: '3px',
    width: '78px',
  },
}

export default function VpsButton() {
  const vpsLogin = () => {
    window.location.replace(`${window.location.origin}/api/v1/login_start`)
  }

  return (
    <>
      <Box sx={sx.label}>Pieslēgties ar</Box>
      <Button onClick={vpsLogin} variant="outlined" color="primary" sx={sx.btn}>
        <img src={logo} style={sx.img} alt="Pieslēgties ar Latvija.lv" />
      </Button>
    </>
  )
}
